import { render, staticRenderFns } from "./servicesPage.vue?vue&type=template&id=80ac5056&scoped=true"
import script from "./servicesPage.vue?vue&type=script&lang=js"
export * from "./servicesPage.vue?vue&type=script&lang=js"
import style0 from "./servicesPage.vue?vue&type=style&index=0&id=80ac5056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ac5056",
  null
  
)

export default component.exports